import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, ITestimonial } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-people-reviews',
  templateUrl: './people-reviews.component.html',
  styleUrls: ['./people-reviews.component.scss']
})
export class PeopleReviewsComponent implements OnInit {

  @Input() midwife: IDashboardMidwifePayload;
  testimonials: Array<ITestimonial> = [];
  testimonials1: Array<ITestimonial> = [];
  testimonials2: Array<ITestimonial> = [];

  constructor() { }

  ngOnInit(): void {
    if(this.midwife.testimonials)
    {
      let totalTestimonials = this.midwife.testimonials.length;
      this.testimonials = this.midwife.testimonials;
      if(totalTestimonials % 2 == 1)
      {
        this.testimonials1 = this.midwife.testimonials.slice(0, totalTestimonials / 2 + 1);
        this.testimonials2 = this.midwife.testimonials.slice(totalTestimonials / 2 + 1);
      }
      else{
        this.testimonials1 = this.midwife.testimonials.slice(0, totalTestimonials / 2);
        this.testimonials2 = this.midwife.testimonials.slice(totalTestimonials / 2);
      }
    }
  }
}